module.exports = " <a href=javascript:; class=vc-item v-el:item :class=\"{'vc-item-link': link, 'vc-item-ripple': ripple || link}\"> <slot></slot> <ripple v-if=\"ripple || link\" :trigger=$els.item></ripple> </a> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/list/item.vue
 ** module id = 452
 ** module chunks = 1
 **/